/* Naoko — LP „Black Friday VIP — Blink blink bańki” (docs/lp-bf-vip-banki-plan.md): JS skórki naoko-bfb-*.
   Silnik zapisu, ?typ=1, wjazdu, kotwic i kopiowania to assets/naoko-vip.js; tu tylko:
   - bańki w hero (canvas): symulacja z makiety 1:1 (rozkład, siły, rysowanie, ucieczka przed
     kursorem / palcem); pętla stoi, gdy hero jest poza ekranem, a przy prefers-reduced-motion
     rysowany jest jeden kadr,
   - rozbijanie baniek w sekcji naoko-bfb-pop (klasa is-open, aria-expanded, kropelki); po rozbiciu
     bańka traci hak GTM, żeby kolejne kliknięcia w otwartą bańkę nie liczyły się drugi raz,
   - animacje CSS sekcji wstrzymane poza ekranem (klasa is-off).
   Każda sekcja dołącza ten skrypt — blokada drugiego uruchomienia. */
(function () {
  if (window.NaokoBfb) return;
  window.NaokoBfb = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var COLORS = ['#FF5FB4', '#FF9F45', '#FFE36B', '#6CF0D2', '#5AA9FF', '#B07CFF', '#FF5FB4'];

  /* ---------------- Bańki w hero ---------------- */
  function initBubs(cv) {
    if (cv.dataset.bfbReady) return;
    cv.dataset.bfbReady = '1';
    var cx = cv.getContext && cv.getContext('2d');
    var hero = cv.parentElement;
    var hin = hero && hero.querySelector('.nbfb-hin');
    if (!cx || !hero || !hin) return;
    var Z = 0, W = 0, H = 0, dpr = 1, B = [];
    var P = { x: -9999, y: -9999, a: false, vx: 0, vy: 0, sx: -9999, sy: -9999, k: 0 };
    var t = 0, raf = 0, vis = false;

    function size() {
      if (!cv.isConnected || !cv.offsetWidth || !cv.offsetHeight) return;
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      var oW = W, oH = H;
      W = cv.offsetWidth;
      H = cv.offsetHeight;
      Z = W < 760 ? Math.max(150, hin.offsetTop - 4) : H;
      if (B.length && oW && oH && B.mob === (W < 760)) {
        for (var i = 0; i < B.length; i++) { B[i].x *= W / oW; B[i].y *= H / oH; }
      }
      cv.width = W * dpr;
      cv.height = H * dpr;
      cx.setTransform(dpr, 0, 0, dpr, 0, 0);
      if (B.length && B.mob !== (W < 760)) B = [];
      if (!B.length) {
        var mob = W < 760;
        B.mob = mob;
        var x0 = mob ? 0 : W * 0.46;
        var G = mob ? [[3, 38, 54], [11, 18, 34], [24, 8, 16], [22, 4, 7]] : [[6, 70, 110], [16, 34, 62], [34, 12, 28], [34, 5, 10]];
        var R = [];
        G.forEach(function (g) { for (var n = 0; n < g[0]; n++) R.push(g[1] + Math.random() * (g[2] - g[1])); });
        R.forEach(function (r) {
          var x, y, ok = false;
          for (var k = 0; k < 400 && !ok; k++) {
            x = x0 + r * 0.6 + Math.random() * (W - x0 - r * 0.6);
            y = Math.random() * Z;
            ok = B.every(function (o) { return Math.hypot(o.hx * W - x, o.hy * H - y) > o.r + r + (mob ? 2 : 4); });
          }
          if (ok) B.push({ hx: x / W, hy: y / H, x: x, y: y, r: r, vx: 0, vy: 0, h: Math.random() * 360, s: 0.3 + Math.random() * 0.6, ph: Math.random() * 6.283 });
        });
      }
    }

    function draw(tt) {
      cx.clearRect(0, 0, W, H);
      for (var i = 0; i < B.length; i++) {
        var b = B[i];
        var g = cx.createRadialGradient(b.x, b.y, b.r * 0.2, b.x, b.y, b.r);
        g.addColorStop(0, 'rgba(255,255,255,0.02)');
        g.addColorStop(0.72, 'rgba(255,255,255,0.05)');
        g.addColorStop(0.92, 'rgba(220,200,255,0.16)');
        g.addColorStop(1, 'rgba(255,255,255,0.28)');
        cx.fillStyle = g;
        cx.beginPath(); cx.arc(b.x, b.y, b.r, 0, 6.283); cx.fill();
        var rim;
        if (cx.createConicGradient) {
          rim = cx.createConicGradient((b.h + tt * b.s * 0.6) * Math.PI / 180, b.x, b.y);
          COLORS.forEach(function (c, n) { rim.addColorStop(n / 6, c); });
        } else {
          rim = 'rgba(255,170,220,.8)';
        }
        cx.globalAlpha = 0.85; cx.strokeStyle = rim; cx.lineWidth = Math.max(1.5, b.r * 0.06);
        cx.beginPath(); cx.arc(b.x, b.y, b.r * 0.97, 0, 6.283); cx.stroke();
        cx.globalAlpha = 0.35; cx.lineWidth = b.r * 0.16;
        cx.beginPath(); cx.arc(b.x, b.y, b.r * 0.88, 0, 6.283); cx.stroke();
        cx.globalAlpha = 1;
        cx.fillStyle = 'rgba(255,255,255,.75)';
        cx.beginPath(); cx.ellipse(b.x - b.r * 0.38, b.y - b.r * 0.42, b.r * 0.2, b.r * 0.1, -0.7, 0, 6.283); cx.fill();
        cx.fillStyle = 'rgba(255,255,255,.35)';
        cx.beginPath(); cx.arc(b.x + b.r * 0.42, b.y + b.r * 0.45, b.r * 0.06, 0, 6.283); cx.fill();
      }
    }

    function step(tt) {
      P.k += ((P.a ? 1 : 0) - P.k) * (P.a ? 0.08 : 0.03);
      P.sx += (P.x - P.sx) * 0.2; P.sy += (P.y - P.sy) * 0.2;
      P.vx *= 0.88; P.vy *= 0.88;
      var mob = W < 760, x0 = mob ? 0 : W * 0.46, i, b;
      for (i = 0; i < B.length; i++) {
        b = B[i];
        if (P.k > 0.01) {
          var dx = b.x - P.sx, dy = b.y - P.sy, d = Math.hypot(dx, dy) || 1, Rr0 = b.r + (mob ? 100 : 190);
          if (d < Rr0) {
            var u = 1 - d / Rr0, w = u * u * (3 - 2 * u) * P.k, f = w * (mob ? 0.7 : 1);
            b.vx += dx / d * f + P.vx * 0.04 * w;
            b.vy += dy / d * f + P.vy * 0.04 * w;
          }
        }
        b.vx += Math.sin(tt * 0.012 * b.s + b.ph) * 0.004;
        b.vy += Math.cos(tt * 0.009 * b.s + b.ph) * 0.004;
        var L = x0 + b.r * 0.6, Rr = W - b.r * 0.4, T = b.r * 0.3, Bt = mob ? Z - b.r * 0.5 : H - b.r * 0.3;
        if (b.x < L) b.vx += (L - b.x) * 0.008;
        if (b.x > Rr) b.vx -= (b.x - Rr) * 0.008;
        if (b.y < T) b.vy += (T - b.y) * 0.008;
        if (b.y > Bt) b.vy -= (b.y - Bt) * 0.008;
        b.vx *= 0.93; b.vy *= 0.93;
        var sp = Math.hypot(b.vx, b.vy);
        if (sp > 4) { b.vx *= 4 / sp; b.vy *= 4 / sp; }
        b.x += b.vx; b.y += b.vy;
      }
      for (i = 0; i < B.length; i++) {
        for (var k = i + 1; k < B.length; k++) {
          var a = B[i], c = B[k], ddx = c.x - a.x, ddy = c.y - a.y, dd = Math.hypot(ddx, ddy) || 1, m = a.r + c.r;
          if (dd < m) {
            var o = (m - dd) / 2, nx = ddx / dd, ny = ddy / dd, s = 0.02;
            a.x -= nx * o; a.y -= ny * o; c.x += nx * o; c.y += ny * o;
            a.vx -= nx * s * o; a.vy -= ny * s * o; c.vx += nx * s * o; c.vy += ny * s * o;
          }
        }
      }
      draw(tt);
    }

    function pt(e) {
      if (W < 760 && e.pointerType === 'mouse' && !e.buttons) return;
      var r = cv.getBoundingClientRect();
      var p = e.touches ? e.touches[0] : e;
      var nx = p.clientX - r.left, ny = p.clientY - r.top;
      if (P.a) { P.vx = P.vx * 0.7 + (nx - P.x) * 0.3; P.vy = P.vy * 0.7 + (ny - P.y) * 0.3; }
      else { P.sx = nx; P.sy = ny; }
      P.x = nx; P.y = ny; P.a = true;
    }
    function release() { P.a = false; P.vx = P.vy = 0; }
    hero.addEventListener('pointermove', pt);
    hero.addEventListener('pointerdown', pt);
    hero.addEventListener('pointerleave', release);
    hero.addEventListener('pointerup', function () { if (W < 760) P.a = false; });
    hero.addEventListener('touchstart', pt, { passive: true });
    hero.addEventListener('touchmove', pt, { passive: true });
    hero.addEventListener('touchend', release);

    function loop() {
      if (!cv.isConnected) { raf = 0; return; }
      t++;
      step(t);
      raf = requestAnimationFrame(loop);
    }
    function sync() {
      var run = vis && !reduced.matches;
      if (run && !raf) raf = requestAnimationFrame(loop);
      if (!run && raf) { cancelAnimationFrame(raf); raf = 0; }
    }
    function onResize() { size(); if (!raf) draw(t); }

    size();
    draw(t);
    window.addEventListener('resize', onResize);
    if ('ResizeObserver' in window) new ResizeObserver(onResize).observe(cv);
    if (reduced.addEventListener) reduced.addEventListener('change', sync);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { vis = en[0].isIntersecting; sync(); }).observe(hero);
    } else {
      vis = true;
      sync();
    }
  }

  /* ---------------- Rozbijanie baniek ---------------- */
  function popBubble(b) {
    if (b.classList.contains('is-open')) return;
    b.classList.add('is-open');
    b.setAttribute('aria-expanded', 'true');
    var R = b.offsetWidth * 0.5;
    for (var i = 0; i < 18; i++) {
      var d = document.createElement('span');
      var a = i / 18 * 6.283 + Math.random() * 0.3;
      var r = R * (1.05 + Math.random() * 0.35);
      d.className = 'nbfb-drop';
      d.style.cssText = '--c:' + COLORS[i % 6] + ';--x:' + (Math.cos(a) * r).toFixed(1) + 'px;--y:' + (Math.sin(a) * r).toFixed(1) + 'px';
      b.appendChild(d);
      setTimeout(d.remove.bind(d), 800);
    }
    /* po obsłudze tego kliknięcia przez GTM: kolejne kliknięcia w otwartą bańkę bez zdarzenia */
    setTimeout(function () { b.removeAttribute('data-gtm-el'); }, 300);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.nbfb-pop .nbfb-bub');
    if (b) popBubble(b);
  });

  /* ---------------- Animacje CSS poza ekranem ---------------- */
  var offIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { en.target.classList.toggle('is-off', !en.isIntersecting); });
  }, { rootMargin: '100px 0px' }) : null;

  function init(scope) {
    var r = scope || document;
    r.querySelectorAll('[data-bfb-bubs]').forEach(initBubs);
    if (offIO) {
      r.querySelectorAll('.nbfb[data-bfb-anim]').forEach(function (el) {
        if (el.dataset.bfbAnimReady) return;
        el.dataset.bfbAnimReady = '1';
        offIO.observe(el);
      });
    }
  }

  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
